import { PayMCopyDateModelType, payMCopyDateStatusInversed } from '@teinor/erp/types/company/accounting/payMCopy/payMCopyDate';

const notIncluded = [payMCopyDateStatusInversed['divided'], payMCopyDateStatusInversed['grouped'], payMCopyDateStatusInversed['payed'], payMCopyDateStatusInversed['pending_pay']]

export const parsePaymentMethodDatesToGroup = (paymentCopyDates: PayMCopyDateModelType[]) => {
    const result: PayMCopyDateModelType[] = []
    for (const element of paymentCopyDates) {
        if (!notIncluded.includes(element.status)){
            result.push(element)
        }
    }
    return result
}